import { useEffect, useState } from 'react';

const SPLASH_KEY = 'client-pwa-v2-splash-shown';

export default function SplashV2() {
  const [visible, setVisible] = useState(() => {
    try { return sessionStorage.getItem(SPLASH_KEY) !== '1'; } catch { return true; }
  });

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => dismiss(), 2600);
    return () => clearTimeout(timer);
  }, [visible]);

  const dismiss = () => {
    try { sessionStorage.setItem(SPLASH_KEY, '1'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      onClick={dismiss}
      className="fixed inset-0 z-[100] overflow-hidden bg-[#2a2a3a] text-white animate-in fade-in duration-500"
    >
      {/* Animated gradient blobs */}
      <div className="absolute -left-1/4 -top-1/4 h-[700px] w-[700px] animate-pulse rounded-full bg-violet-600/40 blur-[140px]" />
      <div className="absolute -right-1/4 top-1/3 h-[500px] w-[500px] animate-pulse rounded-full bg-fuchsia-600/30 blur-[120px]" style={{ animationDelay: '600ms' }} />
      <div className="absolute bottom-0 left-1/2 h-[400px] w-[400px] -translate-x-1/2 animate-pulse rounded-full bg-cyan-500/20 blur-[100px]" style={{ animationDelay: '1100ms' }} />

      <div className="relative flex h-full flex-col items-center justify-between px-8 pb-12 pt-20">
        <div className="flex flex-1 flex-col items-center justify-center text-center">
          {/* Hex/diamond logo */}
          <div className="relative mb-8">
            <div className="h-28 w-28 rotate-45 rounded-3xl bg-gradient-to-br from-violet-500 via-fuchsia-500 to-amber-400 shadow-2xl shadow-fuchsia-500/40" />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-3xl font-black tracking-tighter">VA</span>
            </div>
          </div>

          <p className="text-[10px] font-medium uppercase tracking-[0.4em] text-white/50">
            Beacon Accounting
          </p>
          <h1 className="mt-6 text-4xl font-black leading-none tracking-tight">
            James Tiling
          </h1>
          <p className="mt-1 text-lg font-light tracking-wide text-white/60">Pty Ltd</p>

          <div className="mt-10 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur-md">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
            <span className="text-[11px] font-medium text-white/70">Connecting your data…</span>
          </div>
        </div>

        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-white/40">
          <span>Powered by</span>
          <span className="bg-gradient-to-r from-violet-400 via-fuchsia-400 to-amber-300 bg-clip-text font-bold text-transparent">
            RoniDoc
          </span>
        </div>
      </div>
    </div>
  );
}
